import { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { ChevronDown } from "lucide-react";
import { customRenderRichText } from "../utils/renderRichText";

const AccordionItem = ({ blok }) => {
  const [isOpen, setIsOpen] = useState(false);
  const light = blok.light_mode;

  return (
    <div
      {...storyblokEditable(blok)}
      className="py-6 transition-colors duration-300"
    >
      {/* Accordion Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center text-left"
      >
        <h3
          className={`text-lg md:text-xl font-medium transition-colors duration-300 ${
            // Title should always be blue in both modes
            "#1371DC"
          }`}
          style={{ color: "#1371DC" }}
        >
          {blok.title}
        </h3>

        {/* Arrow Icon */}
        <ChevronDown
          className={`w-6.5 h-6.5 transform transition-transform duration-300 ${
            light ? "text-black" : "text-white"
          } ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {/* Accordion Body */}
      <div
        className={`mt-3 transition-all duration-500 ease-in-out ${
          isOpen
            ? "max-h-[1000px] opacity-100"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div
          className={`accordion-content pt-2 text-sm md:text-base leading-relaxed space-y-3 transition-colors duration-300 ${
            light ? "text-black" : "text-gray-300"
          }`}
        >
          {blok.body &&
            (typeof blok.body === "string"
              ? blok.body
              : customRenderRichText(blok.body))}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
